module.exports = __webpack_public_path__ + "static/2-386667514958f1f01faab918d5a44b67.gif";